<script>
  import { onMount } from 'svelte';
  import { editStore, sessionStore, logout, resetImageStore, updateRionBalance } from '../stores';
  import { signOutSession } from '../utils/authSession';
  import { getRionBalance } from '../utils/apiClient';
  import { t } from '../i18n';

  let showInfo = false;
  
  function handleEditorV2Click() {
    sessionStorage.removeItem('fromDashboard');
    sessionStorage.removeItem('currentTaskId');
    editStore.update(store => ({
      ...store,
      selectedTab: 'upload',
      selectedFeature: null,
      isLoading: false,
      loadingText: '',
      showFeatureModal: false,
      editHistory: [],
      currentEditIndex: -1,
      dogFact: null,
      currentTaskId: null,
      hideOverlayForCurrentTask: false
    }));
    resetImageStore();
    navigateTo('editorv2');
  }

  async function fetchBalance() {
    if ($sessionStore.loggedIn && $sessionStore.userId) {
      const data = await getRionBalance($sessionStore.userId);
      if (data) {
        updateRionBalance(data.total_rion ?? data.balance ?? 0);
      }
    }
  }

  onMount(() => {
    fetchBalance();
    // 30초마다 갱신
    const interval = setInterval(fetchBalance, 30000);
    return () => clearInterval(interval);
  });

  // props 추가
  export let navigateTo;
  export let currentPage;
  
</script>

<header class="app-header">
  <div class="header-container">
    <button 
      type="button"
      class="logo-button" 
      on:click={() => {
        // 홈페이지 최상단으로 이동
        window.scrollTo(0, 0);
        // 홈페이지로 이동
        navigateTo('home');
        // 편집기에서 업로드 탭으로 이동
        editStore.update(store => ({ ...store, selectedTab: 'upload' }));
      }}
      aria-label={$t('home')}
    >
      <img src="/images/이리온 아이콘.png" alt="이리온 로고" class="logo-image light-logo" />
      <img src="/images/이리온 아이콘.png" alt="이리온 로고" class="logo-image dark-logo" />
      <span class="logo-text">E-RION</span>
    </button>

    <nav aria-label="E-RION">
      <ul>
        <li>
          <button 
            type="button" 
            class:active={currentPage === 'home'} 
            on:click={() => navigateTo('home')}
            aria-current={currentPage === 'home' ? 'page' : undefined}
          >
            {$t('home')}
          </button>
        </li>
        <li>
          <button
            type="button"
            class:active={currentPage === 'dashboard'}
            on:click={() => navigateTo('dashboard')}
            aria-current={currentPage === 'dashboard' ? 'page' : undefined}
          >
            {$t('dashboard')}
          </button>
        </li>
        <li><button type="button" class:active={currentPage === 'community'} on:click={() => navigateTo('community')}>{$t('community')}</button></li>
        <li><button type="button" class:active={currentPage === 'dog-chat'} on:click={() => navigateTo('dog-chat')}>{$t('dogChat')}</button></li>
        <li><button type="button" class:active={currentPage === 'about'} aria-current={currentPage === 'about' ? 'page' : undefined} on:click={() => navigateTo('about')}>{$t('about')}</button></li>
        <li><button type="button" class:active={currentPage === 'photo-ideas'} aria-current={currentPage === 'photo-ideas' ? 'page' : undefined} on:click={() => navigateTo('photo-ideas')}>{$t('photo-ideas')}</button></li>
        <li><button type="button" class:active={currentPage === 'faq'} aria-current={currentPage === 'faq' ? 'page' : undefined} on:click={() => navigateTo('faq')}>{$t('faq')}</button></li>
        <!-- <li>
          <button
            type="button"
            class:active={currentPage === 'editor'}
            on:click={() => navigateTo('editor')}
            aria-current={currentPage === 'editor' ? 'page' : undefined}
          >
            {$t('editor')}
          </button>
        </li> -->
        <li>
          <button
            type="button"
            class:active={currentPage.startsWith('editorv2')}
            on:click={handleEditorV2Click}
            aria-current={currentPage.startsWith('editorv2') ? 'page' : undefined}
          >
            {$t('editor')}
          </button>
        </li>
        <li>
          <button
            type="button"
            class:active={currentPage === 'api-docs'}
            on:click={() => navigateTo('api-docs')}
            aria-current={currentPage === 'api-docs' ? 'page' : undefined}
          >
            {$t('apiDocs')}
          </button>
        </li>
        <!-- <li>
          <button
            type="button"
            class:active={currentPage === 'finetuning'}
            on:click={() => navigateTo('finetuning')}
            aria-current={currentPage === 'finetuning' ? 'page' : undefined}
          >
            파인튜닝
          </button>
        </li> -->
        <!-- <li>
          <button 
            type="button" 
            class:active={currentPage === 'batch'} 
            on:click={() => navigateTo('batch')}
            aria-current={currentPage === 'batch' ? 'page' : undefined}
          >
            배치처리
          </button>
        </li> -->
      </ul>
    </nav>
    
    <div class="header-actions">
      {#if $sessionStore.loggedIn}
        <div class="welcome-container">
          <div class="rion-display">
            <img src="/images/rion_icon.png" alt="RION" class="rion-icon" on:error={(e) => e.target.src = "/favicon.png"} />
            <span class="rion-amount">{$sessionStore.rionBalance.toLocaleString()} RION</span>
          </div>
          <span class="welcome">{$t('welcome', { name: $sessionStore.name })}</span>
        </div>
      {/if}
      <button type="button" class="mypage-btn" on:click={() => navigateTo('settings')}>{$t('settings')}</button>
      {#if $sessionStore.loggedIn}
        <button type="button" class="logout-btn" on:click={() => { signOutSession(); navigateTo('home'); }}>{$t('logout')}</button>
      {:else}
        <button type="button" class="login-btn-header" on:click={() => navigateTo('login')}>{$t('login')}</button>
      {/if}
    </div>
  </div>
</header>

<style>
  nav ul { flex-wrap: wrap; justify-content: center; }
  /* 헤더 컨테이너 */
  .header-container {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
  }

  .logo-button { justify-self: start; }

  .header-actions {
    justify-self: end;
  }

  /* 기존 AppHeader.svelte 스타일 */
  .app-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.65rem 1rem;
    width: 100%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 100;
  }
  
  :global(.dark) .app-header {
    background-color: #1a1a1a;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  :global(.light) .app-header {
    background-color: #ffffff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  
  /* 로고 버튼 스타일 */
  .logo-button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: transform 0.3s ease;
  }

  .logo-image {
    width: 1.8rem;
    height: 1.8rem;
    margin-right: 0.3rem;
  }

  .dark-logo {
    display: none;
  }

  :global(.dark) .light-logo {
    display: none;
  }

  :global(.dark) .dark-logo {
    display: block;
  }
  
  .logo-button:hover {
    transform: scale(1.05);
  }
  
  .logo-button:focus-visible {
    outline: 2px solid #FE6A37;
    outline-offset: 4px;
    border-radius: 4px;
  }
  
  /* 로고 텍스트 */
  .logo-text {
    font-family: 'HakgyoansimDunggeunmisoTTF-B', sans-serif;
    font-size: 1.8rem;
    font-weight: 700;
    background: #1a1a1a;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    white-space: nowrap;
  }

  :global(.dark) .logo-text {
    background: rgb(247, 247, 247);
    background-clip: text;
  }
  
  /* 네비게이션 스타일 */
  nav {
    display: flex;
    justify-content: center;
    min-width: 0;
    overflow: hidden;
  }

  nav ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 0.25rem;
    flex-wrap: wrap;
    white-space: nowrap;
  }
  
  nav li {
    margin: 0;
  }
  
  nav button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    font: inherit;
    font-size: 1rem;
    font-weight: 500;
    line-height: normal;
    color: inherit;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    transition: all 0.3s ease;
    font-family: inherit;
  }
  
  :global(.dark) nav button {
    color: #f5f5f5;
  }
  
  :global(.light) nav button {
    color: #404040;
  }
  
  nav button:hover {
    background-color: rgba(254, 106, 55, 0.1);
  }
  
  nav button:focus-visible {
    outline: 2px solid #FE6A37;
    outline-offset: 2px;
  }
  
  nav button.active {
    background-color: rgba(254, 106, 55, 0.2);
    color: #FE6A37;
    font-weight: 600;
  }

  /* 우측 아이콘 영역 */
  .header-actions {
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }

  .header-actions button {
    white-space: nowrap;
  }

  .welcome {
    font-weight: 600;
    margin-right: 0.5rem;
  }

  .welcome-container {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .rion-display {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    background-color: rgba(254, 106, 55, 0.1);
    padding: 0.3rem 0.6rem;
    border-radius: 20px;
    border: 1px solid rgba(254, 106, 55, 0.2);
  }

  .rion-icon {
    width: 1.2rem;
    height: 1.2rem;
  }

  .rion-amount {
    font-weight: 700;
    color: #FE6A37;
    font-size: 0.9rem;
  }

  .mypage-btn {
    margin-left: 0.5rem;
    background-color: #FE6A37;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
  }

  .mypage-btn:hover {
    background-color: #e35d32;
  }

  .logout-btn {
    background: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    font-size: 0.85rem;
  }

  :global(.dark) .logout-btn {
    color: #ccc;
    border-color: #444;
  }

  .login-btn-header {
    background-color: #FE6A37;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
  }

  /* .login-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
  }

  .login-btn:focus-visible {
    outline: 2px solid #FE6A37;
    outline-offset: 4px;
    border-radius: 6px;
  }

  :global(.dark) .login-btn {
    color: rgb(255, 255, 255);
  } */
  
  /* 반응형 디자인 */

  /* ── 1050px 이하: nav 버튼 간격 축소 ── */
  @media (max-width: 1050px) {
    nav button {
      padding: 0.45rem 0.7rem;
      font-size: 0.93rem;
    }
    .welcome-container { gap: 0.6rem; }
  }

  /* ── 900px 이하: 환영 텍스트 숨김, RION 표시 유지 ── */
  @media (max-width: 900px) {
    nav button {
      padding: 0.4rem 0.55rem;
      font-size: 0.88rem;
    }
    .welcome { display: none; }
    .header-actions { gap: 0.4rem; }
  }

  /* ── 780px 이하: RION 표시도 숨김 ── */
  @media (max-width: 780px) {
    .rion-display { display: none; }
    nav button {
      padding: 0.35rem 0.45rem;
      font-size: 0.85rem;
    }
    .app-header { padding: 0.55rem 0.75rem; }
  }

  /* ── 600px 이하: 로고 텍스트 숨김, nav 버튼 최소화 ── */
  @media (max-width: 600px) {
    .logo-text { display: none; }
    .logo-image { margin-right: 0; }
    nav button {
      padding: 0.3rem 0.4rem;
      font-size: 0.82rem;
    }
    .mypage-btn, .logout-btn {
      padding: 0.22rem 0.4rem;
      font-size: 0.8rem;
    }
  }
  @media (max-width: 800px) {
    .header-container { grid-template-columns: 1fr auto; grid-template-rows: auto auto; gap: 8px; }
    .logo-button { grid-column: 1; grid-row: 1; }
    .header-actions { grid-column: 2; grid-row: 1; white-space: nowrap; }
    .header-actions button { white-space: nowrap; }
    nav { grid-column: 1 / -1; grid-row: 2; justify-content: flex-start; overflow-x: auto; }
    nav ul { gap: 4px; padding-bottom: 3px; flex-wrap: nowrap; }
  }
  @media (min-width: 801px) { .header-container { grid-template-columns: auto minmax(0, 1fr) auto; } }
</style>
